import { connectToggleRefinement } from 'react-instantsearch-dom';
import styled from "styled-components";

import Checkbox from "./Checkbox";

const ItemLabel = styled.span`
  margin-left: 8px;
  font-family: Open Sans, sans-serif;;
  font-size: 16px;
  font-weight: ${(props) => (props.checked ? 600 : "normal")};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.disabled ? '#95938D' : "#2c271c")};
}`;

const ItemCount = styled.span`
border: none;
font-family: Open Sans, sans-serif;;
font-size: 12px;
font-weight: 600;
font-stretch: normal;
font-style: normal;
line-height: 1.42;
letter-spacing: normal;
text-align: center;
color: #2c271c;
text-align: center;
text-decoration: none;
display: inline-block;
padding: 1px 4px 1px;
border-radius: 10px;
background-color: #e6e6e6;
margin-left: 5px;
}`;

const ToggleRefinement = ({ currentRefinement, refine, label, count, canRefine, value, defaultChecked }) => {
  //console.log('ToggleRefinement', currentRefinement);
  //console.log('ToggleRefinementcount', count);
  let itemCount = count.unchecked ? count.unchecked : 0;
  //let is_checked = !currentRefinement;

  let is_checked = currentRefinement;

  if (defaultChecked === true) {
    is_checked = currentRefinement !== true ? true : false;
    const checkedCount = typeof count.checked !== 'undefined' ? count.checked : 0;
    const uncheckedCount = typeof count.unchecked !== 'undefined' ? count.unchecked : 0;
    itemCount = checkedCount - uncheckedCount;
  }

  const toggle = ()=> {
    if (defaultChecked === false) {
      refine(!currentRefinement)
    } else{
      refine(!currentRefinement);
    }
  }

  return (
    <div>
    <ul style={{ listStyle: "none outside none" }}>
        <li>
          <label>
            <Checkbox disabled={itemCount > 0 ? false : true} checked={is_checked} onChange={() => {
              if (canRefine) { toggle(currentRefinement) }
            }} />
            <ItemLabel checked={is_checked} disabled={itemCount > 0 ? false : true}>
              {label}
              <ItemCount>{itemCount}</ItemCount>
            </ItemLabel>
          </label>
        </li>
    </ul>
  </div>
);
}

const ToggleButtonRefinement = connectToggleRefinement(ToggleRefinement);
export default ToggleButtonRefinement;
